import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, createBlock as _createBlock, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "container sub_page _news" }
const _hoisted_2 = { class: "sub_page_con wrap_1120" }
const _hoisted_3 = { class: "total_num" }
const _hoisted_4 = { class: "total_num_value" }
const _hoisted_5 = {
  key: 0,
  class: "btn_wrap _default right_btn _board_type"
}
const _hoisted_6 = { class: "con_card sub_page_con_view" }
const _hoisted_7 = ["for"]
const _hoisted_8 = ["id", "value"]
const _hoisted_9 = { class: "img_wrap" }
const _hoisted_10 = ["src"]
const _hoisted_11 = {
  key: 1,
  src: "img/no_img1.png",
  alt: ""
}
const _hoisted_12 = { class: "tit_wrap" }
const _hoisted_13 = { class: "elips_2" }
const _hoisted_14 = { class: "tit_date" }
const _hoisted_15 = ["for"]
const _hoisted_16 = ["id", "value", "onUpdate:modelValue"]
const _hoisted_17 = { class: "img_wrap" }
const _hoisted_18 = ["src"]
const _hoisted_19 = { class: "tit_wrap" }
const _hoisted_20 = { class: "elips_2" }
const _hoisted_21 = { class: "tit_date" }
const _hoisted_22 = {
  key: 1,
  class: "tbody_li no_data"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Header = _resolveComponent("Header")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_PageBtn = _resolveComponent("PageBtn")!
  const _component_ModalDefault = _resolveComponent("ModalDefault")!
  const _component_Footer = _resolveComponent("Footer")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_Header, { class: "sub_menu active" }),
    _createElementVNode("div", _hoisted_1, [
      _cache[7] || (_cache[7] = _createStaticVNode("<section class=\"sub_page_tit\"><div class=\"deco_wrap\"><i class=\"deco_02\"><img src=\"img/news_left.png\"></i><i class=\"deco_03 _xsmall spin3\"><img src=\"img/b_icon_03.png\"></i><i class=\"deco_04 _xxsmall blink_zoom1\"><img src=\"img/b_icon_04.png\"></i><i class=\"deco_05 _xxxsmall blink_blink1\"><img src=\"img/b_icon_04.png\"></i><i class=\"deco_06\"><img src=\"img/line_circle.png\"></i><i class=\"deco_07 _small spin_blink2\"><img src=\"img/b_icon_01.png\"></i><i class=\"deco_08 _xsmall blink_blink3\"><img src=\"img/b_icon_04.png\"></i><i class=\"deco_09 _xsmall blink2\"><img src=\"img/b_icon_02.png\"></i><i class=\"deco_character\"><img src=\"img/news_icon.png\"></i></div><div class=\"banner_wrap wrap_1120\"><h2>자료집</h2></div></section>", 1)),
      _createElementVNode("section", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _cache[2] || (_cache[2] = _createElementVNode("span", null, "Total", -1)),
          _createElementVNode("span", _hoisted_4, _toDisplayString($setup.state.totalLength), 1)
        ]),
        ($setup.state.hasAuth)
          ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
              _createElementVNode("button", {
                type: "button",
                class: "common_btn _gray",
                onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => ($setup.isDelete && $setup.isDelete(...args)))
              }, "삭제"),
              _createVNode(_component_router_link, {
                class: "common_btn w_130",
                to: "/ArchiveWrite"
              }, {
                default: _withCtx(() => [...(_cache[3] || (_cache[3] = [
                  _createTextVNode("글쓰기", -1)
                ]))]),
                _: 1
              })
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("ul", null, [
            ($setup.state.list.length > 0)
              ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList($setup.state.list, (item) => {
                  return (_openBlock(), _createElementBlock("li", {
                    class: "checkbox_wrap",
                    key: item.idx
                  }, [
                    (!$setup.state.isMobile)
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                          _createElementVNode("label", {
                            for: item.idx + '',
                            class: "card_tag"
                          }, [
                            ($setup.state.hasAuth)
                              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                  _withDirectives(_createElementVNode("input", {
                                    type: "checkbox",
                                    name: "chk",
                                    id: item.idx + '',
                                    value: item.idx,
                                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (($setup.state.idxList) = $event))
                                  }, null, 8, _hoisted_8), [
                                    [_vModelCheckbox, $setup.state.idxList]
                                  ]),
                                  _cache[4] || (_cache[4] = _createElementVNode("em", null, null, -1))
                                ], 64))
                              : _createCommentVNode("", true)
                          ], 8, _hoisted_7),
                          _createVNode(_component_router_link, {
                            to: { name: 'ArchiveView', params: { id: item.idx } }
                          }, {
                            default: _withCtx(() => [
                              _createElementVNode("div", _hoisted_9, [
                                (item.thumbnail)
                                  ? (_openBlock(), _createElementBlock("img", {
                                      key: 0,
                                      src: item.thumbnail,
                                      alt: ""
                                    }, null, 8, _hoisted_10))
                                  : (_openBlock(), _createElementBlock("img", _hoisted_11))
                              ]),
                              _createElementVNode("div", _hoisted_12, [
                                _createElementVNode("div", _hoisted_13, _toDisplayString(item.title), 1),
                                _createElementVNode("div", _hoisted_14, _toDisplayString($setup.CommonUtils.dateFormat(new Date(item.createDate), ".", true)), 1)
                              ])
                            ]),
                            _: 2
                          }, 1032, ["to"])
                        ], 64))
                      : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                          _createElementVNode("label", {
                            for: item.idx + '',
                            class: "card_tag"
                          }, [
                            ($setup.state.hasAuth)
                              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                  _withDirectives(_createElementVNode("input", {
                                    type: "checkbox",
                                    name: "chk",
                                    id: item.idx + '',
                                    value: item.idx,
                                    "onUpdate:modelValue": ($event: any) => ((item.idx) = $event)
                                  }, null, 8, _hoisted_16), [
                                    [_vModelCheckbox, item.idx]
                                  ]),
                                  _cache[5] || (_cache[5] = _createElementVNode("em", null, null, -1))
                                ], 64))
                              : _createCommentVNode("", true)
                          ], 8, _hoisted_15),
                          _createVNode(_component_router_link, {
                            to: { name: 'ArchiveView', params: { id: item.idx } }
                          }, {
                            default: _withCtx(() => [
                              _createElementVNode("div", _hoisted_17, [
                                (item.thumbnail)
                                  ? (_openBlock(), _createElementBlock("img", {
                                      key: 0,
                                      src: item.thumbnail,
                                      alt: ""
                                    }, null, 8, _hoisted_18))
                                  : _createCommentVNode("", true)
                              ]),
                              _createElementVNode("div", _hoisted_19, [
                                _createElementVNode("div", _hoisted_20, _toDisplayString(item.title), 1),
                                _createElementVNode("div", _hoisted_21, _toDisplayString($setup.CommonUtils.dateFormatForMobile(new Date(item.createDate), ".", true)), 1)
                              ])
                            ]),
                            _: 2
                          }, 1032, ["to"])
                        ], 64))
                  ]))
                }), 128))
              : (_openBlock(), _createElementBlock("li", _hoisted_22, [...(_cache[6] || (_cache[6] = [
                  _createElementVNode("div", { class: "tr_div" }, [
                    _createElementVNode("div", {
                      class: "tb_subject",
                      style: {"text-align":"center","width":"100%"}
                    }, "등록된 게시물이 없습니다.")
                  ], -1)
                ]))]))
          ])
        ]),
        ($setup.state.list.length !== 0)
          ? (_openBlock(), _createBlock(_component_PageBtn, {
              key: 1,
              currentPage: $setup.state.page,
              totalLength: $setup.state.totalLength,
              perPage: $setup.state.size,
              onOnPaging: $setup.handlePageChange
            }, null, 8, ["currentPage", "totalLength", "perPage", "onOnPaging"]))
          : _createCommentVNode("", true)
      ]),
      ($setup.modal.isShow)
        ? (_openBlock(), _createBlock(_component_ModalDefault, {
            key: 0,
            type: $setup.modal.tab,
            title: $setup.modal.title,
            content: $setup.modal.content,
            onClose: $setup.closeModal,
            onCallback: $setup.callBackModal
          }, null, 8, ["type", "title", "content", "onClose", "onCallback"]))
        : _createCommentVNode("", true)
    ]),
    _createVNode(_component_Footer)
  ], 64))
}